import styled from "styled-components";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";

import Layout from "components/Layout";
import ButtonPrimary from "components/buttons/ButtonPrimary";
import SectionTitle from "components/text/SectionTitle";

import bagDollarIcon from "assets/img/icons/bag-dollar-icon.svg";
import megaphoneYellowIcon from "assets/img/icons/megaphone-yellow-icon.svg";

const SelectGoalPage = styled.div`
  margin: 60px auto 0;
  width: 100%;
  max-width: 700px;

  padding: 0 10px;
  box-sizing: border-box;

  @media (max-width: ${globalConstants.switchMobile}) {
    margin: 30px auto 0;
  }
`;

const SelectGoal = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0;
  padding: 0 28px;

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    padding: 0;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BackIconWrap = styled.div``;

const Box = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const TopBoxContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const Heading = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
  font-size: 24px;
`;

const Text = styled.div`
  max-width: 480px;

  line-height: 125%;
  text-align: center;
`;

const SelectionBoxes = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const SelectionBox = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_SECONDARY};
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: ${css.BOX_RADIUS_SECONDARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};

  flex: 1;
`;

const SelectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SelectionTitleIcon = styled.div`
  width: 18px;
  min-width: 18px;

  transform: ${(props) => `translateY(${props.translate})`};
`;

const SelectionTitle = styled.div`
  font-weight: 500;
`;

const SelectionText = styled.div``;

const SelectionButtonWrap = styled.div`
  margin-top: 8px;

  display: flex;
`;

const BottomInfo = styled.div`
  font-size: 14px;
`;

export default () => {
  const navigate = useNavigate();

  // set page Title
  useEffect(() => {
    document.title = "Select Your Goal | Scalelup";
  }, []);

  return (
    <SelectGoalPage>
      <Layout noColumns={true}>
        <SelectGoal>
          <Header>
            <SectionTitle marginTop="16px">
              Decide What You Want to Start With
            </SectionTitle>
          </Header>
          <Box>
            <TopBoxContent>
              <Heading>What Is Your Goal?</Heading>
              <Text>
                Choose whether you want to create a post and promote your offer
                to others, or start earning right away by viewing posts.
              </Text>
            </TopBoxContent>
            <SelectionBoxes>
              <SelectionBox>
                <SelectionTitleRow>
                  <SelectionTitleIcon translate="2px">
                    <img src={megaphoneYellowIcon} style={{ width: "100%" }} />
                  </SelectionTitleIcon>
                  <SelectionTitle>Promote My Business</SelectionTitle>
                </SelectionTitleRow>
                <SelectionText>
                  I want to present my product, service, or business
                  opportunity.
                </SelectionText>
                <SelectionButtonWrap>
                  <ButtonPrimary onClick={() => navigate("/post-tutorial")}>
                    Create Post
                  </ButtonPrimary>
                </SelectionButtonWrap>
              </SelectionBox>
              <SelectionBox>
                <SelectionTitleRow>
                  <SelectionTitleIcon translate="1px">
                    <img src={bagDollarIcon} style={{ width: "100%" }} />
                  </SelectionTitleIcon>
                  <SelectionTitle>Earn Money</SelectionTitle>
                </SelectionTitleRow>
                <SelectionText>
                  I'm not selling anything, I want to earn on the Scalelup
                  platform.
                </SelectionText>
                <SelectionButtonWrap>
                  <ButtonPrimary onClick={() => navigate("/discover")}>
                    Start Earning
                  </ButtonPrimary>
                </SelectionButtonWrap>
              </SelectionBox>
            </SelectionBoxes>
            <BottomInfo>
              You can always choose the other option later.
            </BottomInfo>
          </Box>
        </SelectGoal>
      </Layout>
    </SelectGoalPage>
  );
};
